import {Meta, Title} from '@angular/platform-browser';
import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-page-meta',
    template: ''
})

export class PageMetaComponent implements OnInit {
    @Input() pageTitle: string;
    @Input() tags: string;
    @Input() description: string;

    constructor(private title: Title, private meta: Meta) {
    }

    public ngOnInit() {
        this.title.setTitle(this.pageTitle);
        this.meta.updateTag({name: 'keywords', content: this.tags});
        this.meta.updateTag({name: 'description', content: this.description});
    }
}
